/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AjaxResponseOfCompanyDto } from '../models/ajax-response-of-company-dto';
import { CompanyDto } from '../models/company-dto';
import { FieldConfigDto } from '../models/field-config-dto';
import { FieldConfigInputDto } from '../models/field-config-input-dto';
import { InvoiceProfileDto } from '../models/invoice-profile-dto';
import { LabelDto } from '../models/label-dto';
import { LocationDto } from '../models/location-dto';
import { TravelPolicyDto } from '../models/travel-policy-dto';

@Injectable({
  providedIn: 'root',
})
export class CompanyService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getCompany_1
   */
  static readonly GetCompany_1Path = '/api/services/app/Company/GetCompany';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCompany_1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompany_1$Response(params?: {
  }): Observable<StrictHttpResponse<AjaxResponseOfCompanyDto>> {

    const rb = new RequestBuilder(this.rootUrl, CompanyService.GetCompany_1Path, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AjaxResponseOfCompanyDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getCompany_1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompany_1(params?: {
  }): Observable<AjaxResponseOfCompanyDto> {

    return this.getCompany_1$Response(params).pipe(
      map((r: StrictHttpResponse<AjaxResponseOfCompanyDto>) => r.body as AjaxResponseOfCompanyDto)
    );
  }

  /**
   * Path part for operation getLocationAutocomplete_1
   */
  static readonly GetLocationAutocomplete_1Path = '/api/services/app/Company/GetLocationAutocomplete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLocationAutocomplete_1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLocationAutocomplete_1$Response(params: {
    text: string;
  }): Observable<StrictHttpResponse<Array<LocationDto>>> {

    const rb = new RequestBuilder(this.rootUrl, CompanyService.GetLocationAutocomplete_1Path, 'get');
    if (params) {
      rb.query('text', params.text, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<LocationDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getLocationAutocomplete_1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLocationAutocomplete_1(params: {
    text: string;
  }): Observable<Array<LocationDto>> {

    return this.getLocationAutocomplete_1$Response(params).pipe(
      map((r: StrictHttpResponse<Array<LocationDto>>) => r.body as Array<LocationDto>)
    );
  }

  /**
   * Path part for operation createOrUpdateCompany
   */
  static readonly CreateOrUpdateCompanyPath = '/api/services/app/Company/CreateOrUpdateCompany';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOrUpdateCompany()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createOrUpdateCompany$Response(params?: {
    body?: CompanyDto
  }): Observable<StrictHttpResponse<CompanyDto>> {

    const rb = new RequestBuilder(this.rootUrl, CompanyService.CreateOrUpdateCompanyPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CompanyDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createOrUpdateCompany$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createOrUpdateCompany(params?: {
    body?: CompanyDto
  }): Observable<CompanyDto> {

    return this.createOrUpdateCompany$Response(params).pipe(
      map((r: StrictHttpResponse<CompanyDto>) => r.body as CompanyDto)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOrUpdateCompany$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  createOrUpdateCompany$Xml$Response(params?: {
    body?: CompanyDto
  }): Observable<StrictHttpResponse<CompanyDto>> {

    const rb = new RequestBuilder(this.rootUrl, CompanyService.CreateOrUpdateCompanyPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+xml');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CompanyDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createOrUpdateCompany$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  createOrUpdateCompany$Xml(params?: {
    body?: CompanyDto
  }): Observable<CompanyDto> {

    return this.createOrUpdateCompany$Xml$Response(params).pipe(
      map((r: StrictHttpResponse<CompanyDto>) => r.body as CompanyDto)
    );
  }

  /**
   * Path part for operation createOrUpdateTravelPolicy
   */
  static readonly CreateOrUpdateTravelPolicyPath = '/api/services/app/Company/CreateOrUpdateTravelPolicy';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOrUpdateTravelPolicy()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createOrUpdateTravelPolicy$Response(params?: {
    body?: TravelPolicyDto
  }): Observable<StrictHttpResponse<AjaxResponseOfCompanyDto>> {

    const rb = new RequestBuilder(this.rootUrl, CompanyService.CreateOrUpdateTravelPolicyPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AjaxResponseOfCompanyDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createOrUpdateTravelPolicy$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createOrUpdateTravelPolicy(params?: {
    body?: TravelPolicyDto
  }): Observable<AjaxResponseOfCompanyDto> {

    return this.createOrUpdateTravelPolicy$Response(params).pipe(
      map((r: StrictHttpResponse<AjaxResponseOfCompanyDto>) => r.body as AjaxResponseOfCompanyDto)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOrUpdateTravelPolicy$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  createOrUpdateTravelPolicy$Xml$Response(params?: {
    body?: TravelPolicyDto
  }): Observable<StrictHttpResponse<AjaxResponseOfCompanyDto>> {

    const rb = new RequestBuilder(this.rootUrl, CompanyService.CreateOrUpdateTravelPolicyPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+xml');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AjaxResponseOfCompanyDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createOrUpdateTravelPolicy$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  createOrUpdateTravelPolicy$Xml(params?: {
    body?: TravelPolicyDto
  }): Observable<AjaxResponseOfCompanyDto> {

    return this.createOrUpdateTravelPolicy$Xml$Response(params).pipe(
      map((r: StrictHttpResponse<AjaxResponseOfCompanyDto>) => r.body as AjaxResponseOfCompanyDto)
    );
  }

  /**
   * Path part for operation deleteTravelPolicy
   */
  static readonly DeleteTravelPolicyPath = '/api/services/app/Company/DeleteTravelPolicy';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteTravelPolicy()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTravelPolicy$Response(params?: {
    travelPolicyId?: string;
  }): Observable<StrictHttpResponse<AjaxResponseOfCompanyDto>> {

    const rb = new RequestBuilder(this.rootUrl, CompanyService.DeleteTravelPolicyPath, 'delete');
    if (params) {
      rb.query('travelPolicyId', params.travelPolicyId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AjaxResponseOfCompanyDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteTravelPolicy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTravelPolicy(params?: {
    travelPolicyId?: string;
  }): Observable<AjaxResponseOfCompanyDto> {

    return this.deleteTravelPolicy$Response(params).pipe(
      map((r: StrictHttpResponse<AjaxResponseOfCompanyDto>) => r.body as AjaxResponseOfCompanyDto)
    );
  }

  /**
   * Path part for operation createOrUpdateInvoiceProfile
   */
  static readonly CreateOrUpdateInvoiceProfilePath = '/api/services/app/Company/CreateOrUpdateInvoiceProfile';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOrUpdateInvoiceProfile()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createOrUpdateInvoiceProfile$Response(params?: {
    body?: InvoiceProfileDto
  }): Observable<StrictHttpResponse<CompanyDto>> {

    const rb = new RequestBuilder(this.rootUrl, CompanyService.CreateOrUpdateInvoiceProfilePath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CompanyDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createOrUpdateInvoiceProfile$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createOrUpdateInvoiceProfile(params?: {
    body?: InvoiceProfileDto
  }): Observable<CompanyDto> {

    return this.createOrUpdateInvoiceProfile$Response(params).pipe(
      map((r: StrictHttpResponse<CompanyDto>) => r.body as CompanyDto)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOrUpdateInvoiceProfile$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  createOrUpdateInvoiceProfile$Xml$Response(params?: {
    body?: InvoiceProfileDto
  }): Observable<StrictHttpResponse<CompanyDto>> {

    const rb = new RequestBuilder(this.rootUrl, CompanyService.CreateOrUpdateInvoiceProfilePath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+xml');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CompanyDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createOrUpdateInvoiceProfile$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  createOrUpdateInvoiceProfile$Xml(params?: {
    body?: InvoiceProfileDto
  }): Observable<CompanyDto> {

    return this.createOrUpdateInvoiceProfile$Xml$Response(params).pipe(
      map((r: StrictHttpResponse<CompanyDto>) => r.body as CompanyDto)
    );
  }

  /**
   * Path part for operation deleteInvoiceProfile
   */
  static readonly DeleteInvoiceProfilePath = '/api/services/app/Company/DeleteInvoiceProfile';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteInvoiceProfile()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteInvoiceProfile$Response(params?: {
    invoiceProfileId?: string;
  }): Observable<StrictHttpResponse<CompanyDto>> {

    const rb = new RequestBuilder(this.rootUrl, CompanyService.DeleteInvoiceProfilePath, 'delete');
    if (params) {
      rb.query('invoiceProfileId', params.invoiceProfileId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CompanyDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteInvoiceProfile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteInvoiceProfile(params?: {
    invoiceProfileId?: string;
  }): Observable<CompanyDto> {

    return this.deleteInvoiceProfile$Response(params).pipe(
      map((r: StrictHttpResponse<CompanyDto>) => r.body as CompanyDto)
    );
  }

  /**
   * Path part for operation getInvoiceProfile
   */
  static readonly GetInvoiceProfilePath = '/api/services/app/Company/GetInvoiceProfile';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getInvoiceProfile()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInvoiceProfile$Response(params?: {
    invoiceProfileId?: string;
  }): Observable<StrictHttpResponse<InvoiceProfileDto>> {

    const rb = new RequestBuilder(this.rootUrl, CompanyService.GetInvoiceProfilePath, 'get');
    if (params) {
      rb.query('invoiceProfileId', params.invoiceProfileId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InvoiceProfileDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getInvoiceProfile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInvoiceProfile(params?: {
    invoiceProfileId?: string;
  }): Observable<InvoiceProfileDto> {

    return this.getInvoiceProfile$Response(params).pipe(
      map((r: StrictHttpResponse<InvoiceProfileDto>) => r.body as InvoiceProfileDto)
    );
  }

  /**
   * Path part for operation createOrUpdateLabel
   */
  static readonly CreateOrUpdateLabelPath = '/api/services/app/Company/CreateOrUpdateLabel';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOrUpdateLabel()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createOrUpdateLabel$Response(params?: {
    body?: LabelDto
  }): Observable<StrictHttpResponse<CompanyDto>> {

    const rb = new RequestBuilder(this.rootUrl, CompanyService.CreateOrUpdateLabelPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CompanyDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createOrUpdateLabel$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createOrUpdateLabel(params?: {
    body?: LabelDto
  }): Observable<CompanyDto> {

    return this.createOrUpdateLabel$Response(params).pipe(
      map((r: StrictHttpResponse<CompanyDto>) => r.body as CompanyDto)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOrUpdateLabel$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  createOrUpdateLabel$Xml$Response(params?: {
    body?: LabelDto
  }): Observable<StrictHttpResponse<CompanyDto>> {

    const rb = new RequestBuilder(this.rootUrl, CompanyService.CreateOrUpdateLabelPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+xml');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CompanyDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createOrUpdateLabel$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  createOrUpdateLabel$Xml(params?: {
    body?: LabelDto
  }): Observable<CompanyDto> {

    return this.createOrUpdateLabel$Xml$Response(params).pipe(
      map((r: StrictHttpResponse<CompanyDto>) => r.body as CompanyDto)
    );
  }

  /**
   * Path part for operation deleteLabel
   */
  static readonly DeleteLabelPath = '/api/services/app/Company/DeleteLabel';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteLabel()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteLabel$Response(params?: {
    labelId?: string;
  }): Observable<StrictHttpResponse<CompanyDto>> {

    const rb = new RequestBuilder(this.rootUrl, CompanyService.DeleteLabelPath, 'delete');
    if (params) {
      rb.query('labelId', params.labelId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CompanyDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteLabel$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteLabel(params?: {
    labelId?: string;
  }): Observable<CompanyDto> {

    return this.deleteLabel$Response(params).pipe(
      map((r: StrictHttpResponse<CompanyDto>) => r.body as CompanyDto)
    );
  }

  /**
   * Path part for operation archiveLabel
   */
  static readonly ArchiveLabelPath = '/api/services/app/Company/ArchiveLabel';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `archiveLabel()` instead.
   *
   * This method doesn't expect any request body.
   */
  archiveLabel$Response(params?: {
    labelId?: string;
  }): Observable<StrictHttpResponse<CompanyDto>> {

    const rb = new RequestBuilder(this.rootUrl, CompanyService.ArchiveLabelPath, 'post');
    if (params) {
      rb.query('labelId', params.labelId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CompanyDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `archiveLabel$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  archiveLabel(params?: {
    labelId?: string;
  }): Observable<CompanyDto> {

    return this.archiveLabel$Response(params).pipe(
      map((r: StrictHttpResponse<CompanyDto>) => r.body as CompanyDto)
    );
  }

  /**
   * Path part for operation getFieldsConfig
   */
  static readonly GetFieldsConfigPath = '/api/services/app/Company/GetFieldsConfig';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFieldsConfig()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFieldsConfig$Response(params?: {
  }): Observable<StrictHttpResponse<Array<FieldConfigDto>>> {

    const rb = new RequestBuilder(this.rootUrl, CompanyService.GetFieldsConfigPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<FieldConfigDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getFieldsConfig$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFieldsConfig(params?: {
  }): Observable<Array<FieldConfigDto>> {

    return this.getFieldsConfig$Response(params).pipe(
      map((r: StrictHttpResponse<Array<FieldConfigDto>>) => r.body as Array<FieldConfigDto>)
    );
  }

  /**
   * Path part for operation createOrUpdateFieldConfig
   */
  static readonly CreateOrUpdateFieldConfigPath = '/api/services/app/Company/CreateOrUpdateFieldConfig';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOrUpdateFieldConfig()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createOrUpdateFieldConfig$Response(params?: {
    body?: FieldConfigInputDto
  }): Observable<StrictHttpResponse<Array<FieldConfigDto>>> {

    const rb = new RequestBuilder(this.rootUrl, CompanyService.CreateOrUpdateFieldConfigPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<FieldConfigDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createOrUpdateFieldConfig$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createOrUpdateFieldConfig(params?: {
    body?: FieldConfigInputDto
  }): Observable<Array<FieldConfigDto>> {

    return this.createOrUpdateFieldConfig$Response(params).pipe(
      map((r: StrictHttpResponse<Array<FieldConfigDto>>) => r.body as Array<FieldConfigDto>)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOrUpdateFieldConfig$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  createOrUpdateFieldConfig$Xml$Response(params?: {
    body?: FieldConfigInputDto
  }): Observable<StrictHttpResponse<Array<FieldConfigDto>>> {

    const rb = new RequestBuilder(this.rootUrl, CompanyService.CreateOrUpdateFieldConfigPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+xml');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<FieldConfigDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createOrUpdateFieldConfig$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  createOrUpdateFieldConfig$Xml(params?: {
    body?: FieldConfigInputDto
  }): Observable<Array<FieldConfigDto>> {

    return this.createOrUpdateFieldConfig$Xml$Response(params).pipe(
      map((r: StrictHttpResponse<Array<FieldConfigDto>>) => r.body as Array<FieldConfigDto>)
    );
  }

}
